import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../apiConfig';

// Utility function to create query params string
const createQueryParams = (page, pageSize, filters) => {
  const params = new URLSearchParams();

  if (page) params.append('page', page);
  if (pageSize) params.append('page_size', pageSize);
  if (filters) {
    Object.keys(filters).forEach((key) => {
      if (filters[key]) params.append(key, filters[key]);
    });
  }

  return params.toString();
};

// // Define async thunks for fetching data from each endpoint with optional query parameters
// export const fetchRejectData = createAsyncThunk(
//   'collectionData/fetchRejectData',
//   async ({ jwtBearer, page, pageSize, filters } = {}) => {
//     const queryParams = createQueryParams(page, pageSize, filters);
//     const response = await axios.get(`${BASE_URL}collection/reject/data${queryParams ? `?${queryParams}` : ''}`, {
//       headers: {
//         Authorization: `Bearer ${jwtBearer}`
//       }
//     });
//     return response.data;
//   }
// );


export const fetchRejectData = createAsyncThunk(
  'collectionData/fetchRejectData',
  async ({ jwtBearer, page, pageSize, filters } = {}, { rejectWithValue }) => {
    try {
      const queryParams = createQueryParams(page, pageSize, filters);
      const response = await axios.get(
        `${BASE_URL}collection/reject/data${queryParams ? `?${queryParams}` : ''}`,
        {
          headers: {
            Authorization: `Bearer ${jwtBearer}`
          }
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.location.reload();
      }
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);


export const fetchSuccessData = createAsyncThunk(
  'collectionData/fetchSuccessData',
  async ({ jwtBearer, page, pageSize, filters } = {}) => {
    const queryParams = createQueryParams(page, pageSize, filters);
    const response = await axios.get(`${BASE_URL}collection/success/data${queryParams ? `?${queryParams}` : ''}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}`
      }
    });
    return response.data;
  }
);

export const fetchPendingData = createAsyncThunk(
  'collectionData/fetchPendingData',
  async ({ jwtBearer, page, pageSize, filters } = {}) => {
    const queryParams = createQueryParams(page, pageSize, filters);
    const response = await axios.get(`${BASE_URL}collection/pending/data${queryParams ? `?${queryParams}` : ''}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}`
      }
    });
    return response.data;
  }
);
// export const fetchPendingBaData = createAsyncThunk(
//   'collectionData/fetchPendingBaData',
//   async ({ jwtBearer,filters } = {}) => {
//     const queryParams = createQueryParams( filters);
//     const response = await axios.get(`${BASE_URL}collection/pending/data${queryParams ? `?${queryParams}` : ''}`, {
//       headers: {
//         Authorization: `Bearer ${jwtBearer}`
//       }
//     });
//     return response.data;
//   }
// );

export const fetchPendingBaData = createAsyncThunk(
  'collectionReport/fetchPendingBaData',
  async ({ jwtBearer, filters }, { rejectWithValue }) => {
    try {
      // Ensure filters are formatted correctly
      const response = await axios.get(`${BASE_URL}collection/pending/data`, {
        params: {
          ...filters,
        },
        headers: {
          Authorization: `Bearer ${jwtBearer}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchPendingForApprovalData = createAsyncThunk(
  'collectionData/fetchPendingForApprovalData',
  async ({ jwtBearer, page, pageSize, filters } = {}) => {
    const queryParams = createQueryParams(page, pageSize, filters);
    const response = await axios.get(`${BASE_URL}collection/pending-approval/data${queryParams ? `?${queryParams}` : ''}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}`
      }
    });
    return response.data;
  }
);

export const fetchPendingForAcknowledgementData = createAsyncThunk(
  'collectionData/fetchPendingForAcknowledgementData',
  async ({ jwtBearer, page, pageSize, filters } = {}) => {
    const queryParams = createQueryParams(page, pageSize, filters);
    const response = await axios.get(`${BASE_URL}collection/pending-acknowledgement/data${queryParams ? `?${queryParams}` : ''}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}`
      }
    });
    return response.data;
  }
);

export const fetchRejectFilteredData = createAsyncThunk(
  'collectionData/fetchRejectFilteredData',
  async ({ jwtBearer, filters } = {}) => {
    const queryParams = createQueryParams(null, null, filters);
    const response = await axios.get(`${BASE_URL}collection/reject/data${queryParams ? `?${queryParams}` : ''}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}`
      }
    });
    return response.data;
  }
);

export const fetchSuccessFilteredData = createAsyncThunk(
  'collectionData/fetchSuccessFilteredData',
  async ({ jwtBearer, page, pageSize, filters } = {}) => {
    // const queryParams = createQueryParams(page, pageSize, filters);
    const queryParams = createQueryParams(null, null, filters);
    const response = await axios.get(`${BASE_URL}collection/success/data${queryParams ? `?${queryParams}` : ''}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}`
      }
    });
    return response.data;
  }
);

export const fetchPendingFilteredData = createAsyncThunk(
  'collectionData/fetchPendingFilteredData',
  async ({ jwtBearer, filters } = {}) => {
    const queryParams = createQueryParams(null, null, filters);
    const response = await axios.get(`${BASE_URL}collection/pending/data${queryParams ? `?${queryParams}` : ''}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}`
      }
    });
    return response.data;
  }
);

export const fetchPendingForApprovalFilteredData = createAsyncThunk(
  'collectionData/fetchPendingForApprovalFilteredData',
  async ({ jwtBearer, page, pageSize, filters } = {}) => {
    // const queryParams = createQueryParams(page, pageSize, filters);
    const queryParams = createQueryParams(null, null, filters);
    const response = await axios.get(`${BASE_URL}collection/pending-approval/data${queryParams ? `?${queryParams}` : ''}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}`
      }
    });
    return response.data;
  }
);

export const fetchPendingForAcknowledgementFilteredData = createAsyncThunk(
  'collectionData/fetchPendingForAcknowledgementFilteredData',
  async ({ jwtBearer, page, pageSize, filters } = {}) => {
    // const queryParams = createQueryParams(page, pageSize, filters);
    const queryParams = createQueryParams(null, null, filters);
    const response = await axios.get(`${BASE_URL}collection/pending-acknowledgement/data${queryParams ? `?${queryParams}` : ''}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}`
      }
    });
    return response.data;
  }
);


export const fetchCollectionEfficiency = createAsyncThunk(
  'collection/fetchCollectionEfficiency',
  async ({ jwtBearer, page, pageSize, filters } = {}) => {
    const queryParams = createQueryParams(page, pageSize, filters);
    const response = await axios.get(`${BASE_URL}pipeline/collection/efficiency/${queryParams ? `?${queryParams}` : ''}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}`
      }
    });
    return response.data;
  }
);


export const fetchFilteredCollectionEfficiency = createAsyncThunk(
  'collection/fetchFilteredCollectionEfficiency',
  async ({ jwtBearer, filters } = {}) => {
    const queryParams = createQueryParams(null, null, filters);
    const response = await axios.get(`${BASE_URL}pipeline/collection/efficiency/${queryParams ? `?${queryParams}` : ''}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}`
      }
    });
    return response.data;
  }
);

export const fetchCompleteCollectionEfficiency = createAsyncThunk(
  'collection/fetchCompleteCollectionEfficiency',
  async ({ jwtBearer } = {}) => {
    const response = await axios.get(`${BASE_URL}pipeline/collection/efficiency/`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}`
      }
    });
    return response.data;
  }
);

export const uploadPendingFile = createAsyncThunk(
  'pending/uploadPendingFile',
  async ({ fileObj, jwtBearer }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}collection/upload/pending/file/`,
        { file: fileObj }, 
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${jwtBearer}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const fetchPendingForAckAtBranch = createAsyncThunk(
  'collectionData/fetchPendingForAckAtBranch/',
  async ({ jwtBearer, page, pageSize, filters } = {}) => {
    const queryParams = createQueryParams(page, pageSize, filters);
    const response = await axios.get(`${BASE_URL}collection/pending-ack/at/branch/${queryParams ? `?${queryParams}` : ''}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}`
      }
    });
    // console.log("response.data", response.data);
    return response.data;
  }
);


export const fetchPendingForAckAtBranchFilteredData = createAsyncThunk(
  'collectionData/fetchPendingForAckAtBranchFilteredData',
  async ({ jwtBearer, filters } = {}) => {
    const queryParams = createQueryParams(null, null, filters);
    const response = await axios.get(
      `${BASE_URL}collection/pending-ack/at/branch/${queryParams ? `?${queryParams}` : ''}`, 
      {
        headers: {
          Authorization: `Bearer ${jwtBearer}`
        }
      }
    );
    return response.data;
  }
);

export const fetchFilteredPendingForAckAtBranch = createAsyncThunk(
  'collectionData/fetchFilteredPendingForAckAtBranch',
  async ({ jwtBearer, filters } = {}) => {
    const queryParams = createQueryParams(null, null, filters);
    const response = await axios.get(`${BASE_URL}collection/pending-ack/at/branch/${queryParams ? `?${queryParams}` : ''}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}`
      }
    });
    return response.data;
  }
)

const initialState = {
  rejectData: null,
  successData: null,
  pendingData: null,
  pendingForApprovalData: null,
  pendingForAcknowledgementData: null,
  pendingForAckAtBranchData: null,
  rejectFilteredData: null,
  successFilteredData: null,
  pendingFilteredData: null,
  pendingForApprovalFilteredData: null,
  pendingForAcknowledgementFilteredData: null,


  rejectCount: null,
  successCount: null,
  pendingCount: null,
  pendingForApprovalCount: null,
  pendingForAcknowledgementCount: null,
  pendingForAckAtBranchCount: null,

  errorReject: null,
  errorSuccess: null,
  errorPending: null,
  errorPendingForApproval: null,
  errorPendingForAcknowledgement: null,
  errorRejectFiltered: null,
  errorSuccessFiltered: null,
  errorPendingFiltered: null,
  errorPendingForApprovalFiltered: null,
  errorPendingForAcknowledgementFiltered: null,
  errorPendingForAckAtBranch: null,

  isLoadingSuccess: false,
  isLoadingReject: false,
  isLoadingPending: false,
  isLoadingPendingForApproval: false,
  isLoadingPendingForAcknowledgement: false,
  isLoadingRejectFiltered: false,
  isLoadingSuccessFiltered: false,
  isLoadingPendingFiltered: false,
  isLoadingPendingForApprovalFiltered: false,
  isLoadingPendingForAcknowledgementFiltered: false,
  isLoadingPendingForAckAtBranch: false,

  isLoadingPendingBA: true,
  errorPendingBA: null,
  pendingBAData: null,

    isLoadingCollectionEfficiency: false,
    collectionEfficiencyData: null,
    totalCollectionEfficiencyCount: null,
    errorCollectionEfficiency: null,
  
    isLoadingFilteredCollectionEfficiency: false,
    filteredCollectionEfficiencyData: null,
    errorFilteredCollectionEfficiency: null,

    isLoadingCompleteCollectionEfficiency: false,
    errorCompleteCollectionEfficiency: null,
    collectionEfficiencyOd:null,
    collectionEfficiencyNonOd:null,

};

const collectionDataSlice = createSlice({
  name: 'collectionData',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle thunk states for reject data
      .addCase(fetchRejectData.pending, (state) => {
        state.isLoadingReject = true;
        state.errorReject = null; 
      })
      .addCase(fetchRejectData.fulfilled, (state, action) => {
        state.isLoadingReject = false;
        state.rejectData = action.payload.reject.data;
        state.rejectCount = action.payload.reject.total_count;
      })
      .addCase(fetchRejectData.rejected, (state, action) => {
        state.isLoadingReject = false;
        state.errorReject = action.error.message;
      })

      // Handle thunk states for success data
      .addCase(fetchSuccessData.pending, (state) => {
        state.isLoadingSuccess = true;
        state.errorSuccess = null; 
      })
      .addCase(fetchSuccessData.fulfilled, (state, action) => {
        state.isLoadingSuccess = false;
        state.successData = action.payload.success.data;
        state.successCount = action.payload.success.total_count;
      })
      .addCase(fetchSuccessData.rejected, (state, action) => {
        state.isLoadingSuccess = false;
        state.errorSuccess = action.error.message;
      })

      // Handle thunk states for pending data
      .addCase(fetchPendingData.pending, (state) => {
        state.isLoadingPending = true;
        state.errorPending = null; 
      })
      .addCase(fetchPendingData.fulfilled, (state, action) => {
        state.isLoadingPending = false;
        state.pendingData = action.payload.pending.data;
        state.pendingCount = action.payload.pending.total_count;
      })
      .addCase(fetchPendingData.rejected, (state, action) => {
        state.isLoadingPending = false;
        state.errorPending = action.error.message;
      })




      // Handle thunk states for pending ba data
      .addCase(fetchPendingBaData.pending, (state) => {
        state.isLoadingPendingBA = true;
        state.errorPendingBA = null; 
      })
      .addCase(fetchPendingBaData.fulfilled, (state, action) => {
        state.isLoadingPendingBA = false;
        state.pendingBAData = action.payload.pending.data;

      })
      .addCase(fetchPendingBaData.rejected, (state, action) => {
        state.isLoadingPendingBA = false;
        state.errorPendingBA = action.error.message;
      })

      // Handle thunk states for pending for approval data
      .addCase(fetchPendingForApprovalData.pending, (state) => {
        state.isLoadingPendingForApproval = true;
        state.errorPendingForApproval = null; 
      })
      .addCase(fetchPendingForApprovalData.fulfilled, (state, action) => {
        state.isLoadingPendingForApproval = false;
        state.pendingForApprovalData = action.payload.pending_for_approval.data;
        state.pendingForApprovalCount = action.payload.pending_for_approval.total_count
      })
      .addCase(fetchPendingForApprovalData.rejected, (state, action) => {
        state.isLoadingPendingForApproval = false;
        state.errorPendingForApproval = action.error.message;
      })

      // Handle thunk states for pending for acknowledgement data
      .addCase(fetchPendingForAcknowledgementData.pending, (state) => {
        state.isLoadingPendingForAcknowledgement = true;
        state.errorPendingForAcknowledgement = null; 
      })
      .addCase(fetchPendingForAcknowledgementData.fulfilled, (state, action) => {
        state.isLoadingPendingForAcknowledgement = false;
        state.pendingForAcknowledgementData = action.payload.pending_for_acknowledgement.data;
        state.pendingForAcknowledgementCount = action.payload.pending_for_acknowledgement.total_count
      })
      .addCase(fetchPendingForAcknowledgementData.rejected, (state, action) => {
        state.isLoadingPendingForAcknowledgement = false;
        state.errorPendingForAcknowledgement = action.error.message;
      })

      // Handle thunk states for filtered reject data
      .addCase(fetchRejectFilteredData.pending, (state) => {
        state.isLoadingRejectFiltered = true;
        state.errorRejectFiltered = null; 
      })
      .addCase(fetchRejectFilteredData.fulfilled, (state, action) => {
        state.isLoadingRejectFiltered = false;
        state.rejectFilteredData = action.payload.reject.data;

      })
      .addCase(fetchRejectFilteredData.rejected, (state, action) => {
        state.isLoadingRejectFiltered = false;
        state.errorRejectFiltered = action.error.message;
      })

      // Handle thunk states for filtered success data
      .addCase(fetchSuccessFilteredData.pending, (state) => {
        state.isLoadingSuccessFiltered = true;
        state.errorSuccessFiltered = null; 
      })
      .addCase(fetchSuccessFilteredData.fulfilled, (state, action) => {
        state.isLoadingSuccessFiltered = false;
        state.successFilteredData = action.payload.success.data;
      })
      .addCase(fetchSuccessFilteredData.rejected, (state, action) => {
        state.isLoadingSuccessFiltered = false;
        state.errorSuccessFiltered = action.error.message;
      })

      // Handle thunk states for filtered pending data
      .addCase(fetchPendingFilteredData.pending, (state) => {
        state.isLoadingPendingFiltered = true;
        state.errorPendingFiltered = null; 
      })
      .addCase(fetchPendingFilteredData.fulfilled, (state, action) => {
        state.isLoadingPendingFiltered = false;
        state.pendingFilteredData = action.payload.pending.data;

      })
      .addCase(fetchPendingFilteredData.rejected, (state, action) => {
        state.isLoadingPendingFiltered = false;
        state.errorPendingFiltered = action.error.message;
      })

      // Handle thunk states for filtered pending for approval data
      .addCase(fetchPendingForApprovalFilteredData.pending, (state) => {
        state.isLoadingPendingForApprovalFiltered = true;
        state.errorPendingForApprovalFiltered = null; 
      })
      .addCase(fetchPendingForApprovalFilteredData.fulfilled, (state, action) => {
        state.isLoadingPendingForApprovalFiltered = false;
        state.pendingForApprovalFilteredData = action.payload.pending_for_approval.data;
        state.pendingForApprovalFilteredCount = action.payload.pending_for_approval.total_count;
      })
      .addCase(fetchPendingForApprovalFilteredData.rejected, (state, action) => {
        state.isLoadingPendingForApprovalFiltered = false;
        state.errorPendingForApprovalFiltered = action.error.message;
      })


      // Handle thunk states for filtered pending for acknowledgement data
      .addCase(fetchPendingForAcknowledgementFilteredData.pending, (state) => {
        state.isLoadingPendingForAcknowledgementFiltered = true;
        state.errorPendingForAcknowledgementFiltered = null; 
      })
      .addCase(fetchPendingForAcknowledgementFilteredData.fulfilled, (state, action) => {
        state.isLoadingPendingForAcknowledgementFiltered = false;
        state.pendingForAcknowledgementFilteredData = action.payload.pending_for_acknowledgement.data;
        state.pendingForAcknowledgementFilteredCount = action.payload.pending_for_acknowledgement.total_count;
      })
      .addCase(fetchPendingForAcknowledgementFilteredData.rejected, (state, action) => {
        state.isLoadingPendingForAcknowledgementFiltered = false;
        state.errorPendingForAcknowledgementFiltered = action.error.message;
      })

      
            // Handle thunk states for collection efficiency data
            .addCase(fetchCollectionEfficiency.pending, (state) => {
              state.isLoadingCollectionEfficiency = true;
              state.errorCollectionEfficiency = null; 
            })
            .addCase(fetchCollectionEfficiency.fulfilled, (state, action) => {
              state.isLoadingCollectionEfficiency = false;
              state.collectionEfficiencyData = action.payload.data;
              // console.log("state.collectionEfficiencyData: ", state.collectionEfficiencyData)
              state.totalCollectionEfficiencyCount = action.payload.total_count;
              // console.log("state.totalCollectionEfficiencyCount: ", state.totalCollectionEfficiencyCount)
             
            })
            .addCase(fetchCollectionEfficiency.rejected, (state, action) => {
              state.isLoadingCollectionEfficiency = false;
              state.errorCollectionEfficiency = action.error.message;
            })
      
            // Handle thunk states for filtered collection efficiency data
            .addCase(fetchFilteredCollectionEfficiency.pending, (state) => {
              state.isLoadingFilteredCollectionEfficiency = true;
              state.errorFilteredCollectionEfficiency = null; 
            })
            .addCase(fetchFilteredCollectionEfficiency.fulfilled, (state, action) => {
              state.isLoadingFilteredCollectionEfficiency = false;
              state.filteredCollectionEfficiencyData = action.payload.data;
              // console.log("state.collectionEfficiencyData: ", state.filteredCollectionEfficiencyData)
            })
            .addCase(fetchFilteredCollectionEfficiency.rejected, (state, action) => {
              state.isLoadingFilteredCollectionEfficiency = false;
              state.errorFilteredCollectionEfficiency = action.error.message;
            })


            // Handle thunk states for Complete collection efficiency data
            .addCase(fetchCompleteCollectionEfficiency.pending, (state) => {
              state.isLoadingCompleteCollectionEfficiency = true;
              state.errorCompleteCollectionEfficiency = null; 
            })
            .addCase(fetchCompleteCollectionEfficiency.fulfilled, (state, action) => {
              state.isLoadingFilteredCollectionEfficiency = false;
              state.collectionEfficiencyOvervall = action.payload.collection_efficiency_overall;
              // console.log("state.collectionEfficiencyOd: ", state.collectionEfficiencyOd)
              state.collectionEfficiencyNonOd = action.payload.collection_efficiency_non_od;
              // console.log("state.collectionEfficiencyNonOd: ", state.collectionEfficiencyNonOd)
            })
            .addCase(fetchCompleteCollectionEfficiency.rejected, (state, action) => {
              state.isLoadingCompleteCollectionEfficiency = false;
              state.errorCompleteCollectionEfficiency = action.error.message;
            })

            // state for pending for ack at branch
            .addCase(fetchPendingForAckAtBranch.pending, (state) => {
              state.isLoadingPendingForAckAtBranch = true;
              state.errorPendingForAckAtBranch = null; 
            })
            .addCase(fetchPendingForAckAtBranch.fulfilled, (state, action) => {
              state.isLoadingPendingForAckAtBranch = false;
              state.pendingForAckAtBranchData = action.payload.pending_for_acknowledgement_at_branch.data;
              // console.log("state.pendingForAckAtBranchData: ", state.pendingForAckAtBranchData)
              state.pendingForAckAtBranchCount = action.payload?.pending_for_acknowledgement_at_branch?.total_count;
              console.log("state.pendingForAckAtBranchCount: ", state.pendingForAckAtBranchCount)
            })
            .addCase(fetchPendingForAckAtBranch.rejected, (state, action) => {
              state.isLoadingPendingForAckAtBranch = false;
              state.errorPendingForAckAtBranch = action.error.message;
            })

            // state for filtered pending for ack at branch
            .addCase(fetchPendingForAckAtBranchFilteredData.pending, (state) => {
  state.isLoadingFilteredPendingForAckAtBranch = true;
  state.errorFilteredPendingForAckAtBranch = null; 
})
.addCase(fetchPendingForAckAtBranchFilteredData.fulfilled, (state, action) => {
  state.isLoadingFilteredPendingForAckAtBranch = false;
  state.filteredPendingForAckAtBranchData = action.payload.pending_for_acknowledgement_at_branch.data;
  state.filteredPendingForAckAtBranchCount = action.payload.pending_for_acknowledgement_at_branch.total_count;
})
.addCase(fetchPendingForAckAtBranchFilteredData.rejected, (state, action) => {
  state.isLoadingFilteredPendingForAckAtBranch = false;
  state.errorFilteredPendingForAckAtBranch = action.error.message;
})
      
  }
});

export default collectionDataSlice.reducer;